import "rxjs/add/observable/throw";
import "rxjs/add/operator/timeoutWith";
import "rxjs/add/operator/toPromise";

import { Injectable } from "@angular/core";
import * as _ from "lodash";
import { Observable } from "rxjs/Observable";

import { environment } from "../../environments/environment";
import { BaseService } from "./api-base.service";

import { Carrier } from "../models/carrier.model";
import { ILimitedResult } from "../models/limitedResult";
import { ReconApiService } from "./recon-api.service";
import { HttpClient, HttpParams } from "@angular/common/http";

@Injectable()
export class CarrierService {
  private readonly Timeout: number = 30000;

  constructor(
    private http: HttpClient,
    private apiBase: BaseService,
    private reconApiService: ReconApiService
  ) {}

  public async GetCarriersOfClient(
    clientId: string
  ): Promise<ILimitedResult<Carrier>> {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/DB2Data/Carriers`;

    let params = new HttpParams().set("limit", "100000");

    const response = await this.http
      .get<ILimitedResult<Carrier>>(url, {
        headers: this.apiBase.getHeaders(),
        params: params,
      })
      .timeoutWith(
        this.Timeout,
        Observable.throw(new Error("Timeout exceeded."))
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${
            error && error.status ? error.status.toString() : "unknown"
          }`
        );
        this.reconApiService.logToElasticSearchFromUI(error, url);
      });
    return response;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/carrier-api.service.ts